import styled, { css } from 'styled-components'

export const DriverTipContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 20px;
  padding-bottom: 20px;
  width: 100%;
`

export const TipCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  border: 1px solid #E9ECEF;
  width: 100%;
  height: 50px;
  min-width: 65px;
  max-width: 70px;
  cursor: pointer;
  text-transform: capitalize;
  font-size: 14px;
  color: #B1BCCC;
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    transform: scale(1.05);
  }

  &.active {
    border: 2px solid ${props => props.theme.colors.darkGreen};
    color: ${props => props.theme.colors.darkGreen};
  }

  @media (min-width: 768px) {
    max-width: 95px;
    ${({ isCartPopover }) => isCartPopover && css`
      max-width: 80px;
    `}
  }
`

export const FormDriverTip = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const DriverTipLabel = styled.label`
  font-size: 16px;
  align-self: flex-start;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
  }

  ${props => props.theme?.rtl && css`
    margin-left: 20px;
    margin-right: 0;
  `}
`

export const WrapperInput = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 10px;

  input {
    width: 65%;
    padding: 4px 15px;
    box-sizing: border-box;
    flex: 1;
    margin-right: 10px;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  @media (min-width: 768px) {
    input {
      width: 80%;
    }
  }
`

export const DriverTipMessage = styled.p`
  color: ${props => props.theme.colors.primary};
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
  }
`

export const WrapperTips = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  min-height: 65px;
  > div {
    margin: 5px;
    text-align: center;
    padding-bottom: 0px !important;
    ${({ isDriverTipUseCustom }) => isDriverTipUseCustom && css`
      width: max-content;
    `}
  }
`
